var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.17,
    height: 53.968,
    viewBox: "0 0 74.17 53.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-computing",
    transform: "translate(0 -66.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 66.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M57.954,120.618H42.041v-16.08H47.3a1.645,1.645,0,0,0,1.334-2.607L38.4,87.777a1.63,1.63,0,0,0-2.652,0l-10.23,14.155a1.641,1.641,0,0,0,1.334,2.607h5.259v16.08H14.292C6.335,120.179,0,112.738,0,104.675A15.1,15.1,0,0,1,7.487,91.641a10.122,10.122,0,0,1-.621-3.531A10.265,10.265,0,0,1,17.141,77.835a10.1,10.1,0,0,1,3.516.621,20.571,20.571,0,0,1,39.086,6.79c8.2,1.409,14.428,9,14.428,17.6C74.17,112.025,67.017,119.982,57.954,120.618Z",
    transform: "translate(0 -66.65)",
    fill: "#4397d2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCloud);
export default __webpack_public_path__ + "static/media/blueCloud.79ef4c9e4350ec95f27d797e0da3a3b0.svg";
export { ForwardRef as ReactComponent };